'use strict';

var SelectItem = require('../SelectItem');
function renderLanguageSelectOptions() {
	return {

		getLanguageSelectOptions: function render(config, deps) {
			var _ = deps.underscore;
			var languages = deps.languages;
			var locales = config.CHANNEL_SETTINGS.localeTags;

			return _.reduce(locales, function(result, locale) {
				result += new SelectItem({
					labelRaw: languages[locale],
					value: locale,
					selected: config.locale === locale
				}).render(config, deps);

				return result;
			}, '');
		}
	};
}

module.exports = {
	renderLanguageSelectOptions: renderLanguageSelectOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/language-select-options.js
// module id = 26
// module chunks = 0